module.exports = __webpack_public_path__ + "img/share-tab-normal.90ba1885.png";